import { exportExcel } from "@api/stores/warehouses/batches/exportExcel/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/warehouses/:warehouseId/batches/`;
const pathById = `${pathBase}:batchId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const batches = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  exportExcel,
};
